// @ts-nocheck
import { Box, Button, FlexGap, Grid, Text } from '@pancakeswap/uikit'
import { NextLinkFromReactRouter } from '@pancakeswap/widgets-internal'
import NextLink from 'next/link'
import styled from 'styled-components'

const Landing = () => {
  return (
    <Box as="section" width="100%" mt="2.5rem" position="relative">
      <Grid gridGap={20} maxWidth={850} mx="auto" px={['10px', '10px', '10px', '0px']}>
        <Box maxWidth={708}>
          <Text as="h1" fontFamily="Black Han Sans" fontSize={[30, , , , 40]}>
            Navigate the Future of
            <br /> The Multi-EVM Blockchain DeFi
          </Text>
          <Text
            as="h3"
            fontSize={[16, , , , 22]}
            color="#BEBEBE"
            fontWeight={500}
            fontFamily="Inter"
            maxWidth={[875]}
            mx="auto"
          >
            Seamless integration across multiple EVM chains for enhanced user experience and performance
          </Text>

          <FlexGap justifyContent="space-between" flexWrap="wrap" gap="1rem" pt="2.5rem">
            <NextLinkFromReactRouter as={TradeButton} to="/swap">
              <Text
                fontWeight={500}
                fontFamily="IBM Plex Sans
"
              >
                Trade Now
              </Text>
            </NextLinkFromReactRouter>

            <ListedBox>
              <Text fontWeight={500} fontSize={[20]} fontFamily="IBM Plex Sans" mb="1.5rem">
                Get Listed on
                <Text fontWeight={500} fontSize={[20]} fontFamily="IBM Plex Sans" color="#F47D20" as="span">
                  {` `}Passdex
                </Text>
                !
              </Text>

              <Text fontFamily="IBM Plex Sans" fontSize={[12]} mb="1.5rem">
                Join the Passdex whitelist to get evaluated and potentially listed on our platform.
                <br /> Gain access to our multi-chain ecosystem and connect with a thriving DeFi community.
              </Text>

              <RegisterButton height={[35]} passHref>
                <NextLink href="https://forms.gle/v13SyFQonzxWKbLh6" target="_blank">
                  <Text fontSize={[12]} fontWeight={500} fontFamily="IBM Plex Sans" color="black">
                    Register Whitelist
                  </Text>
                </NextLink>
              </RegisterButton>
            </ListedBox>
          </FlexGap>
        </Box>
      </Grid>

      <PositionGlobal>
        <img src="/images/chains-global.svg" alt="" />
      </PositionGlobal>
    </Box>
  )
}

export default Landing

const TradeButton = styled(Button)`
  max-width: 180px;
  width: 100%;
  box-shadow: none;
`

const ListedBox = styled(Box).attrs({ padding: ['0.8rem 1rem'], maxWidth: ['416px'] })`
  background: linear-gradient(180deg, #ffffff 0%, #737373 100%);
  position: relative;
  z-index: 0;
  border-radius: 10px;

  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;

    border-radius: inherit;
    background: #494a4b;
  }

  & > * {
    position: relative;
    z-index: 2;
  }
`

const RegisterButton = styled(Button)`
  border-radius: 30px;
  box-shadow: none;
  background: white;
  height: 30px;
`

const PositionGlobal = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  right: 0;
`
